/**
 * @generated SignedSource<<628d2bf9d336fa812b775378b5640e1e>>
 * @relayHash 24a6d4fd38ae2e4f6531b5273d2d5073
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24a6d4fd38ae2e4f6531b5273d2d5073

import type { ConcreteRequest } from 'relay-runtime';
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type IssueSingleSelectFieldPickerFieldQuery$variables = {
  id: string;
};
export type IssueSingleSelectFieldPickerFieldQuery$data = {
  readonly node: {
    readonly options?: ReadonlyArray<{
      readonly color: IssueFieldSingleSelectOptionColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
    }>;
  } | null | undefined;
};
export type IssueSingleSelectFieldPickerFieldQuery = {
  response: IssueSingleSelectFieldPickerFieldQuery$data;
  variables: IssueSingleSelectFieldPickerFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueFieldSingleSelectOption",
      "kind": "LinkedField",
      "name": "options",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueSingleSelectFieldPickerFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "IssueSingleSelectFieldPickerFieldQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "24a6d4fd38ae2e4f6531b5273d2d5073",
    "metadata": {},
    "name": "IssueSingleSelectFieldPickerFieldQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "765138124ed0dd0a0ce6df550f7ed38f";

export default node;
